
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon-svg icon-calendar",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16","fill":"var(--iconColor, --current-color-500)"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M12.87 1.448h-1.465V.733c0-.227-.065-.406-.196-.537A.702.702 0 0010.69 0c-.227 0-.406.065-.536.196-.13.13-.196.31-.196.537v.715H5.595V.733c0-.227-.066-.406-.196-.537C5.269.066 5.089 0 4.862 0a.702.702 0 00-.52.196c-.13.13-.196.31-.196.537v.715H2.681c-.613 0-1.13.21-1.55.63C.71 2.5.5 3.017.5 3.63v10.19c0 .613.21 1.13.63 1.55.42.42.938.631 1.551.631h10.19c.613 0 1.13-.21 1.55-.63.42-.42.63-.938.63-1.551V3.629c0-.613-.21-1.13-.63-1.55-.42-.42-.937-.63-1.55-.63zM2.682 2.914h1.465v.715c0 .228.066.406.196.537.131.13.304.196.52.196.227 0 .406-.065.537-.196.13-.13.196-.31.196-.537v-.715h4.362v.715c0 .228.065.406.196.537.13.13.31.196.537.196.215 0 .389-.065.52-.196.13-.13.195-.31.195-.537v-.715h1.466c.215 0 .389.065.52.196.13.13.195.304.195.52v2.18H1.966V3.63c0-.216.065-.39.195-.52a.702.702 0 01.52-.196zm10.19 11.62H2.68a.702.702 0 01-.52-.195.702.702 0 01-.196-.52V7.276h11.621v6.543c0 .216-.065.389-.196.52a.702.702 0 01-.52.196z"}})])
          )
        }
      }
    